// extracted by mini-css-extract-plugin
export default {"container":"Users_container__YAWqG","header":"Users_header__XK0T4","user":"Users_user__5xQOj","name":"Users_name__-N1uh","pending":"Users_pending__cCM8L","live":"Users_live__OZ-CO"};